import {
  ActionCard,
  HeaderPage,
  InfoCard,
  NewModal,
  SearchBarComponent,
  Table2,
} from 'components/index'
import { Icon } from 'assets/index'
import { useContext, useEffect, useState } from 'react'
import { IMAGES } from 'configs/configs.js'
import { IResponse } from 'interfaces'
import Tooltip from 'react-tooltip'
import { UserContext } from 'context'
import { useFetch, useStorage } from 'hooks'
import { PageScrollContent } from 'styles/index'
import ReactSelect from 'react-select'
import { hasAccess } from 'helper/utils'
import DeleteConfirmation from '../../components/DeleteConfirmation'
import { Container, FakeSelect, CellInpput } from './style'
import * as modal from './Modal'
import CustomOption from './SelectCustomOption'
import {
  selectStyles,
  optionsLevels,
  optionsStatus,
  optionsComission,
  optionsPermission,
} from './factory'

export default function Colaboradores() {
  const [modalData, setModalData] = useState<any>([])
  const { showModal, setShowModal, setData, setLoading } =
    useContext(UserContext)
  const [notDisabled, setNotDisabled] = useState<any>('')
  const api = useFetch()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [colaboradores, setColaboradores] = useStorage('Colaboradores')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [especialistas, setEspecialistas] = useStorage('Especialistas')
  const [user] = useStorage('User')
  const [filter, setFilter] = useState('')
  const [gestores, setGestores] = useStorage('Gestores')
  const [gestSpec, setGestSpec] = useStorage('GestSpec')
  const [person, setPerson] = useState<any[]>([]) // dados da tabela para manipulação de filtros voltar ao estado inicial
  const [filterData, setFilterData] = useState<any[]>([]) // Dados filtrados da tabela
  const [pageTable, setPageTable] = useState<number>(1) // Pagina atual da tabela
  const { page, setPage } = useContext(UserContext) // Pagina atual do modal
  const [paginatedData, setPaginatedData] = useState<any[]>([]) // Itens rederizados por pagina da tabela
  const itemsPerPage = 10 // Define items por pagina da tabela
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [idToDelete, setIdToDelete] = useState('')

  const fetchGestorData = async () => {
    try {
      const res = await api.fetch('get', null, '/gestor/gestor')
      const dataWithCounter = res.data.data.map((item: any, index: number) => ({
        ...item,
        counter: index + 1, // Adiciona um contador para cada item da tabela
      }))
      setPerson(dataWithCounter)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchGestorData()
  }, []) // Atualiza a tabela toda vez que a página é carregada

  useEffect(() => {
    if (!showModal) {
      fetchGestorData()
    }
  }, [showModal]) // Atualiza a tabela toda vez que o modal é fechado

  const handleUpdate = async (ev: any, id: string, i: number) => {
    const form = new FormData()

    Object.entries(ev).forEach(([key, value]: any) => {
      if (typeof value === 'object') value = JSON.stringify(value)
      else if (!value) return
      form.append(key, value)
    })

    try {
      const response: IResponse = await api.fetch(
        'put',
        form,
        `/gestor/gestor?id=${id}`,
        { 'Content-Type': 'multipart/form-data' }
      )
      if (response.fail) throw new Error(response.errors.message)

      const colab = await api.fetch('get', null, '/gestor/gestor')

      if (i) {
        const [key, value] = Object.entries(ev)[0]
        const newFilter = [...filterData]
        newFilter[i][key] = value
        setPerson(newFilter)
        setFilterData(newFilter)
      }

      const types: any = {
        GESTOR: String([0, 0, 0, 0, 1, 0, 0, 0, 0]),
        SPECIALIST: String([0, 0, 1, 0, 0, 0, 0, 0, 0]),
        GESTOR_SPECIALIST: String([0, 0, 1, 0, 1, 0, 0, 0, 0]),
      }
      const list: [] = colab.data.data
      ;[
        [setGestores, 'GESTOR'],
        [setEspecialistas, 'SPECIALIST'],
        [setGestSpec, 'GESTOR_SPECIALIST'],
      ].forEach((pair) => {
        const [l, k]: any = pair
        const gList = list
          .filter((usr: any) => String(usr.level) === types[k])
          .map((item: any) => {
            return { ...item, label: item.name, value: item.id }
          })
        l(gList)
      })
      setColaboradores(colab.data.data)
    } catch (err: any) {
      console.error('err', err)
    }
  }

  const handleDelete = async () => {
    try {
      const response: IResponse = await api.fetch(
        'delete',
        null,
        `/gestor/${idToDelete}`
      )
      if (response.fail) throw new Error(response.errors.message)
      setNotDisabled(null)

      if (response.fail) return response
      const updatedPerson = person.filter((item) => item.id !== idToDelete)
      const updatedFilterData = filterData.filter(
        (item) => item.id !== idToDelete
      )

      setPerson(updatedPerson)
      setFilterData(updatedFilterData)
      return response
    } catch (err: any) {
      console.error('err', err)
    }
  }

  useEffect(() => {
    let data = person

    if (filter) {
      const filterByName = data.filter((row: any) =>
        row?.name?.toLowerCase().includes(filter?.toLowerCase())
      )
      data = filterByName
    }

    const start = (pageTable - 1) * itemsPerPage

    const dataWithCounter = data.map((item: any, index: number) => ({
      ...item,
      counter: index + 1, // Adciona um contador para cada item da tabela
    }))
    setFilterData(dataWithCounter) // Update the filter data

    const newPaginatedData = dataWithCounter.slice(start, start + itemsPerPage)
    setPaginatedData(newPaginatedData) // Update the paginated data
  }, [pageTable, person, filter, setFilterData, colaboradores])

  function tableRows(arr: any) {
    if (!arr) return []
    return arr?.map((item: any, i: number) => {
      return [
        <div
          className="grid-item"
          data-testid={`counter-${i}`}
          key={`counter-${i}`}
        >
          {item.counter}
        </div>, // Indice
        <div className="profile-card grid-item" key={`profile-card-${i}`}>
          <img
            className="picture"
            src={`${IMAGES.URL}/images/${item.profilePic}`}
            alt="profile"
            onError={(e) => {
              e.currentTarget.src = `${IMAGES.URL}/images/profile_placeholder.png`
              // caso a imagem não exista, exibe a imagem de perfil padrão
            }}
            data-testid={`profile-pic-${i}`}
          />
          {i === notDisabled ? (
            <input
              type="text"
              defaultValue={item?.name}
              className="grid-input"
              onBlur={(e: any) =>
                handleUpdate({ name: e.target.value }, item.id, i)
              }
              data-testid={`input-name-${i}`}
            />
          ) : (
            <div className="tooltip">
              <p
                data-tip
                data-for={`${item.id}-${i}-name`}
                className="grid-text"
              >
                {item?.name}
              </p>
              <Tooltip id={`${item.id}-${i}-name`} padding={'12px'}>
                <span>{item?.name}</span>
              </Tooltip>
            </div>
          )}
        </div>,
        <div className="grid-item" key={`level-${i}`}>
          {i === notDisabled ? (
            <ReactSelect
              isSearchable={false}
              options={optionsLevels}
              styles={selectStyles}
              placeholder="Selecionar..."
              defaultValue={optionsLevels.find(
                (obj: any) => String(obj.value) === String(item.level)
              )}
              onChange={(e) => {
                handleUpdate({ level: e.value }, item.id, i)
                person.forEach((element: any) => {
                  if (element.id === item.id) {
                    element.level = e.value
                  }
                })
              }}
              data-testid={`access-input-${i}`}
            />
          ) : (
            <FakeSelect>
              <p
                className="text-fake"
                data-tip
                data-for={`${item.id}-${i}-level`}
                data-testid={`fake-access-input-${i}`}
              >
                {
                  optionsLevels.find(
                    (obj: any) => String(obj.value) === String(item.level)
                  )?.label
                }
              </p>
              <Tooltip id={`${item.id}-${i}-level`} padding={'12px'}>
                <span>
                  {
                    optionsLevels.find(
                      (obj: any) => String(obj.value) === String(item.level)
                    )?.label
                  }
                </span>
              </Tooltip>
            </FakeSelect>
          )}
        </div>,

        <div className="grid-item" key={`cellphone-${i}`}>
          {i === notDisabled ? (
            <CellInpput
              type="text"
              defaultValue={item.cellphone}
              className="grid-input"
              mask={'(00) 00000-0000'}
              onBlur={(e: any) => {
                handleUpdate({ cellphone: e.target.value }, item.id, i)
                person.forEach((element: any) => {
                  if (element.id === item.id) {
                    element.cellphone = e.target.value
                  }
                })
              }}
              data-testid={`email-input-${i}`}
            />
          ) : (
            <>
              <p
                className="grid-text"
                data-tip
                data-for={`${item.id}-${i}-cellphone`}
                data-testid={`fake-cellphone-input-${i}`}
              >
                {item?.cellphone}
              </p>
              <Tooltip id={`${item.id}-${i}-cellphone`} padding={'12px'}>
                <span> {item?.cellphone}</span>
              </Tooltip>
            </>
          )}
        </div>, // Celular
        <div className="grid-item" key={`email-${i}`}>
          {i === notDisabled ? (
            <input
              type="text"
              defaultValue={item.email}
              className="grid-input"
              onBlur={(e: any) => {
                handleUpdate({ email: e.target.value }, item.id, i)
                person.forEach((element: any) => {
                  if (element.id === item.id) {
                    element.email = e.target.value
                  }
                })
              }}
              data-testid={`email-input-${i}`}
            />
          ) : (
            <>
              <p
                className="grid-text"
                data-tip
                data-for={`${item.id}-${i}-email`}
                data-testid={`fake-email-input-${i}`}
              >
                {item?.email}
              </p>
              <Tooltip id={`${item.id}-${i}-email`} padding={'12px'}>
                <span> {item?.email}</span>
              </Tooltip>
            </>
          )}
        </div>, // Email

        <div className="grid-item" key={`time-comercial-${i}`}>
          {String(item.level) === String([0, 0, 1, 0, 0, 0, 0, 0, 0]) ? (
            i === notDisabled ? (
              <ReactSelect
                isSearchable={false}
                options={[...gestores, ...gestSpec]}
                styles={selectStyles}
                placeholder="Selecionar..."
                defaultValue={[...gestores, ...gestSpec].find(
                  (obj: any) => String(obj.value) === String(item.superiorId)
                )}
                onChange={(e) => {
                  handleUpdate({ superiorId: e.value }, item.id, i)
                  person.forEach((element: any) => {
                    if (element.id === item.id) {
                      element.superiorId = e.value
                    }
                  })
                }}
                data-testid={`gestors-input-${i}`}
              />
            ) : (
              <FakeSelect>
                <p
                  className="text-fake"
                  data-tip
                  data-for={`${item.id}-${i}-superior`}
                  data-testid={`fake-gestors-input-${i}`}
                >
                  {[...gestores, ...gestSpec].find(
                    (obj: any) => String(obj.value) === String(item.superiorId)
                  )?.label || 'Selecionar...'}
                </p>
                <Tooltip id={`${item.id}-${i}-superior`} padding={'12px'}>
                  <span>
                    {[...gestores, ...gestSpec].find(
                      (obj: any) =>
                        String(obj.value) === String(item.superiorId)
                    )?.label || 'Selecionar...'}
                  </span>
                </Tooltip>
              </FakeSelect>
            )
          ) : (
            <p className="empty-field" data-testid={`empty-gestors-input-${i}`}>
              --
            </p>
          )}
        </div>, // Time Comercial
        <div className="grid-item" key={`status-${i}`}>
          {i === notDisabled ? (
            <ReactSelect
              isSearchable={false}
              options={optionsStatus}
              styles={selectStyles}
              placeholder="Selecionar..."
              defaultValue={optionsStatus.find(
                (obj: any) => String(obj.value) === String(item.status)
              )}
              onChange={(e) => {
                handleUpdate({ status: e.value }, item.id, i)
                person.forEach((element: any) => {
                  if (element.id === item.id) {
                    element.status = e.value
                  }
                })
              }}
              data-testid={`status-input-${i}`}
            />
          ) : (
            <FakeSelect>
              <p className="text-fake" data-testid={`fake-status-input-${i}`}>
                {optionsStatus.find(
                  (obj: any) => String(obj.value) === String(item.status)
                )?.label || 'Selecionar...'}
              </p>
            </FakeSelect>
          )}
        </div>, // Status
        <div className="grid-item" key={`permission-${i}`}>
          {i === notDisabled ? (
            <ReactSelect
              isSearchable={false}
              options={optionsPermission}
              styles={selectStyles}
              placeholder="Selecionar..."
              defaultValue={optionsPermission.find(
                (obj: any) => String(obj.value) === String(item.permission)
              )}
              onChange={(e) => {
                handleUpdate({ permission: e.value }, item.id, i)
                person.forEach((element: any) => {
                  if (element.id === item.id) {
                    element.permission = e.value
                  }
                })
              }}
              data-testid={`permission-input-${i}`}
            />
          ) : (
            <FakeSelect>
              <p
                className="text-fake"
                data-testid={`fake-permission-input-${i}`}
              >
                {optionsPermission.find(
                  (obj: any) => String(obj.value) === String(item.permission)
                )?.label || 'Selecionar...'}
              </p>
            </FakeSelect>
          )}
        </div>, // Permissao
        <div className="grid-action" key={`action-${i}`}>
          <button
            id="change-gestors-info"
            disabled={!hasAccess('change-gestors-info')}
            className="grid-action-btn"
            type="button"
            onClick={() =>
              setNotDisabled((prev: any) => (prev === i ? null : i))
            }
            data-testid={`edit-btn-${i}`}
          >
            {i === notDisabled ? (
              <span className="ok-txt">ok</span> // Texto a ser exibido quando o botão está desativado
            ) : (
              <img src={Icon('edit.svg')} alt="column sorting" />
            )}
          </button>
          <button
            id="delete-gestors"
            type="button"
            className="grid-action-btn"
            disabled={!hasAccess('delete-gestors')}
          >
            <img
              src={Icon('trash.svg')}
              alt="column sorting"
              onClick={() => {
                setIdToDelete(item.id)
                setShowDeleteModal(true)
              }}
              data-testid={`delete-btn-${i}`}
            />
          </button>
        </div>,
      ]
    })
  }

  const openNovoColaborador = async () => {
    setLoading(false)
    setModalData(modal.newGestor)
    setData({})
    setPage(0)
    setShowModal(true)
  }

  const openNewComission = () => {
    setModalData(modal.comission)
    setShowModal(true)
  }

  const columnsWidths = [24, 175, 180, 152, 172, 137, 110, 110, 80]
  const columnGap = 18
  return (
    <Container>
      <HeaderPage path="Gestão de colaboradores" />
      <PageScrollContent flexDirection="column">
        <div className="colaboradores-cards-container">
          <InfoCard icon={Icon('users.svg')} value={`${person?.length}`}>
            Colaboradores
          </InfoCard>
          <ActionCard
            id={'create-new-gestors'}
            disabled={!hasAccess('create-new-gestors')}
            icon={Icon('plus.svg')}
            value={'Novo colaborador'}
            onClick={openNovoColaborador}
          />
          <ActionCard
            icon={Icon('trophy.svg')}
            value={'Comissionamento'}
            onClick={openNewComission}
            disabled
          />
        </div>

        <div className="colaboradores-container-content">
          <div className="colaboradores-container-filter">
            <SearchBarComponent
              width="large"
              dataTestId="search-name"
              placeholder={'Nome do colaborador'}
              onChange={(e: any) => {
                setPageTable(1)
                setFilter(e.target.value)
              }}
            />
          </div>
        </div>
        <div className="table-conteiner">
          <Table2
            pageData={tableRows(paginatedData)}
            filterData={filterData}
            page={pageTable}
            setPage={setPageTable}
            header={[
              '#',
              'COLABORADOR',
              'NÍVEL DE ACESSO',

              'CELULAR',
              'EMAIL',
              'TIME COMERCIAL',
              'STATUS',
              'PERMISSÕES',
              'AÇÃO',
            ]}
            columnsWidths={columnsWidths}
            columnGap={columnGap}
          />
        </div>
      </PageScrollContent>
      <NewModal showModal={showModal} setShowModal={setShowModal}>
        {modalData}
      </NewModal>
      {showDeleteModal && (
        <DeleteConfirmation
          onCancel={() => {
            setShowDeleteModal(false)
          }}
          handleDelete={() => handleDelete()}
          alertTitle="Exclusão definitiva"
          title="Tem certeza que quer excluir?"
          description={[
            'Você está prestes a realizar uma exclusão definitiva no sistema',
            'que não pode ser desfeita, confirma que deseja excluir?',
          ]}
        />
      )}

      {/* <Modal showModal={showModal} setShowModal={setShowModal}>
        {modalData}
      </Modal> */}
    </Container>
  )
}

/* Comissionamento
<div className="grid-item" key={`comission-${i}`}>
  {i === notDisabled ? (
    <ReactSelect
      isSearchable={false}
      options={optionsComission}
      styles={selectStyles}
      placeholder="Selecionar..."
      components={{ Option: CustomOption }}
      defaultValue={optionsComission.find(
        (obj: any) => String(obj.value) === String(item.level)
      )}
      onChange={() => {
        // CRIAR UPDATE DE COMISSIONAMENTO
        // handleUpdate({ level: e.value }, item.id)
      }}
      data-testid={`comission-input-${i}`}
    />
  ) : (
    <FakeSelect>
      <p
        className="text-fake"
        data-testid={`fake-comission-input-${i}`}
      >
        {optionsComission.find(
          (obj: any) => String(obj.value) === String(item.level)
        )?.label || 'Selecionar...'}
      </p>
    </FakeSelect>
  )}
</div>
*/
